import {stage} from './stage';

// Platform-level constants shared across the app. The `portal` URL points
// at the platform's customer portal (used by PlatformHeaderToolbar's
// "Portal" link) and is stage-aware so links from a test deploy go to
// the test portal, not prod.
const portalByStage = {
    prod: 'https://portal.flexi.network',
    test: 'https://portal.test.flexi.network',
    dev: 'https://portal.dev.flexi.network',
    ide: 'https://portal.dev.flexi.network',
};

// The console owns the Account entity, so a person's Account link opens there,
// on the same stage. Directory has no accounts screen of its own.
const consoleByStage = {
    prod: 'https://console.flexi.network',
    test: 'https://console.test.flexi.network',
    dev: 'https://console.dev.flexi.network',
    ide: 'https://console.dev.flexi.network',
};

const platform = {
    appName: 'flexinet-directory-app',
    displayName: 'Flexi Directory',
    description: 'Platform staff list, view, create, edit and delete the people who sign in to Flexi Network.',
    portal: portalByStage[stage] ?? portalByStage.dev,
    console: consoleByStage[stage] ?? consoleByStage.dev,
};

export default platform;
